namespace RedBullMOBILE360.SalesApp {
    export interface AddonRow {
        Id?: string;
        Category?: string;
        NameAr?: string;
        NameEn?: string;
        IsActive?: number;
        Price?: number;
        Benefits?: string;
        Validity?: number;
        BenefitsAr?: string;
        Commission?: number;
        AllowedChannles?: string;
        AllowedIdTypes?: string;
    }

    export namespace AddonRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'SalesApp.Addon';
        export const deletePermission = 'SalesApp:Addon';
        export const insertPermission = 'SalesApp:Addon';
        export const readPermission = 'SalesApp:Addon';
        export const updatePermission = 'SalesApp:Addon';

        export declare const enum Fields {
            Id = "Id",
            Category = "Category",
            NameAr = "NameAr",
            NameEn = "NameEn",
            IsActive = "IsActive",
            Price = "Price",
            Benefits = "Benefits",
            Validity = "Validity",
            BenefitsAr = "BenefitsAr",
            Commission = "Commission",
            AllowedChannles = "AllowedChannles",
            AllowedIdTypes = "AllowedIdTypes"
        }
    }
}
